export default "__VITE_ASSET__c3e926f1__"